module.exports = __webpack_public_path__ + "static/media/imagem_empreendimento.8266ac2b.png";